import React from "react";
import { useTranslation } from "react-i18next";
import { Chip } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";

import { isSessionLive } from "../sessionUtils";

// Statut d'une session. La couleur ne porte jamais l'information seule : le
// libellé et le repère visuel (point clignotant / coche) la doublent.
const SessionStatusChip = ({ session, classes, size = "small" }) => {
  const { t } = useTranslation();
  const live = isSessionLive(session);

  return (
    <Chip
      size={size}
      label={
        <span className={classes.statusChipLabel}>
          {live ? (
            <span className={classes.liveDot} />
          ) : (
            <CheckCircle className={classes.statusChipIcon} />
          )}
          {live ? t("teamPhotos.status.live") : t("teamPhotos.status.ended")}
        </span>
      }
      className={`${classes.statusChip} ${
        live ? classes.statusChipLive : classes.statusChipDone
      }`}
    />
  );
};

export default SessionStatusChip;
